export { default } from './VideoGameMushroom'
